// extracted by mini-css-extract-plugin
export var divider = "_t7-0";
export var systemMessage = "_t7-1";